import { render, staticRenderFns } from "./priceTagEdit.vue?vue&type=template&id=c1973e06&scoped=true&"
import script from "./priceTagEdit.vue?vue&type=script&lang=js&"
export * from "./priceTagEdit.vue?vue&type=script&lang=js&"
import style0 from "./priceTagEdit.vue?vue&type=style&index=0&id=c1973e06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1973e06",
  null
  
)

export default component.exports